import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056d229e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "continue-card h-100" }
const _hoisted_2 = {
  key: 0,
  class: "continue-card-skeleton",
  "aria-busy": "true",
  "aria-live": "polite"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"continue-skeleton-line continue-skeleton-title\" data-v-056d229e></div><div class=\"continue-skeleton-line continue-skeleton-subtitle\" data-v-056d229e></div><div class=\"continue-skeleton-banner\" data-v-056d229e></div><div class=\"continue-skeleton-footer\" data-v-056d229e><div class=\"continue-skeleton-progress\" data-v-056d229e><div class=\"continue-skeleton-line continue-skeleton-progress-text\" data-v-056d229e></div><div class=\"continue-skeleton-track\" data-v-056d229e><div class=\"continue-skeleton-fill\" data-v-056d229e></div></div></div><div class=\"continue-skeleton-btn\" data-v-056d229e></div></div>", 4)
const _hoisted_7 = [
  _hoisted_3
]
const _hoisted_8 = {
  key: 1,
  class: "continue-card-body"
}
const _hoisted_9 = { class: "continue-card-header" }
const _hoisted_10 = { class: "continue-title mb-0" }
const _hoisted_11 = { class: "continue-subtitle mb-0" }
const _hoisted_12 = ["href", "aria-label"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "continue-footer" }
const _hoisted_15 = { class: "continue-progress" }
const _hoisted_16 = { class: "continue-progress-text mb-2" }
const _hoisted_17 = ["aria-valuenow"]
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 2,
  class: "continue-card-empty"
}
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { key: 0 }

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { dashboardService } from "@/modern/services/dashboardService";
import type { ModernPathway } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const FALLBACK_BANNER = "/media/test-pathways.png";

const currentLanguage = computed(
	() => store.getters.getCurrentLanguage || localStorage.getItem("currentLanguage") || "en"
);

const pathway = ref<ModernPathway | null>(null);
const loading = ref(true);
const hasFetchError = ref(false);
const imageFailed = ref(false);

const continueLabel = computed(() => {
	if (currentLanguage.value === "pt") {
		return "Continuar";
	}

	if (currentLanguage.value === "es") {
		return "Continuar";
	}

	return "Continue";
});

const isValidPathway = computed(() => Number(pathway.value?.id ?? 0) > 0);

const displaySubtitle = computed(() => {
	const name = pathway.value?.name?.trim();
	const shortDescription = pathway.value?.short_description?.trim();

	return name || shortDescription || t(`${currentLanguage.value}.page_dashboard.continue_where_you_left_off`);
});

const safeProgress = computed(() => {
	const progress = Number(pathway.value?.percentage_completed ?? 0);

	if (!Number.isFinite(progress)) {
		return 0;
	}

	return Math.min(100, Math.max(0, Math.round(progress)));
});

const pathwayUrl = computed(() => `/training/learning-paths/${pathway.value?.id ?? ""}`);

const bannerSrc = computed(() => {
	const source = pathway.value?.image?.trim();
	if (imageFailed.value || !source) {
		return FALLBACK_BANNER;
	}

	return source;
});

const onBannerError = () => {
	imageFailed.value = true;
};

onBeforeMount(async () => {
	loading.value = true;
	hasFetchError.value = false;

	try {
		pathway.value = await dashboardService.fetchLastPathway();
	} catch (error) {
		hasFetchError.value = true;
		console.error("Error fetching pathway:", error);
	} finally {
		loading.value = false;
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_7))
      : (_unref(isValidPathway))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_unref(continueLabel)), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(displaySubtitle)), 1)
            ]),
            _createElementVNode("a", {
              href: _unref(pathwayUrl),
              class: "continue-banner",
              "aria-label": `${_unref(continueLabel)} ${_unref(displaySubtitle)}`
            }, [
              _createElementVNode("img", {
                src: _unref(bannerSrc),
                alt: "Pathway banner",
                class: "continue-banner-image",
                onError: onBannerError
              }, null, 40, _hoisted_13)
            ], 8, _hoisted_12),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.page_dashboard.progress`)) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(safeProgress)) + "%", 1)
                ]),
                _createElementVNode("div", {
                  class: "continue-progress-track",
                  role: "progressbar",
                  "aria-valuenow": _unref(safeProgress),
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "continue-progress-fill",
                    style: _normalizeStyle({ width: `${_unref(safeProgress)}%` })
                  }, null, 4)
                ], 8, _hoisted_17)
              ]),
              _createElementVNode("a", {
                href: _unref(pathwayUrl),
                class: "continue-action-btn"
              }, _toDisplayString(_unref(continueLabel)), 9, _hoisted_18)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.page_dashboard.continue_where_you_left_off`)), 1),
            (hasFetchError.value)
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.loading`)), 1))
              : _createCommentVNode("", true)
          ]))
  ]))
}
}

})